import React, { useEffect, useState } from "react";

function diffParts(target) {
  const ms = Math.max(0, target.getTime() - Date.now());
  const days = Math.floor(ms / (1000 * 60 * 60 * 24));
  const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((ms / 1000 / 60) % 60);
  const seconds = Math.floor((ms / 1000) % 60);
  return { days, hours, minutes, seconds, total: ms };
}

/**
 * Animated countdown to a target ISO date.
 * Shows Days · Hours · Minutes · Seconds with smooth update.
 */
export default function Countdown({ targetIso, variant = "light" }) {
  const target = new Date(targetIso);
  const [t, setT] = useState(() => diffParts(target));

  useEffect(() => {
    const i = setInterval(() => setT(diffParts(target)), 1000);
    return () => clearInterval(i);
  }, [targetIso]);

  const items = [
    { label: "Jours", value: t.days },
    { label: "Heures", value: t.hours },
    { label: "Minutes", value: t.minutes },
    { label: "Secondes", value: t.seconds },
  ];

  const isDark = variant === "dark";

  return (
    <div className="grid grid-cols-4 gap-2 sm:gap-4" data-testid="countdown">
      {items.map((it, i) => (
        <div
          key={i}
          className={`${isDark ? "bg-white/95 border-white shadow-lg" : "bg-white border-slate-200"} border rounded-xl px-2 sm:px-4 py-4 sm:py-6 text-center`}
          data-testid={`countdown-${it.label.toLowerCase()}`}
        >
          <div className={`font-heading font-extrabold text-3xl sm:text-5xl tracking-tight ${isDark ? "text-[#EA580C]" : "text-[#1E3A8A]"} tabular-nums`}>
            {String(it.value).padStart(2, "0")}
          </div>
          <div className={`text-[10px] sm:text-xs uppercase tracking-[0.18em] font-bold mt-1 ${isDark ? "text-[#1E3A8A]" : "text-slate-500"}`}>
            {it.label}
          </div>
        </div>
      ))}
    </div>
  );
}
